module.exports = __webpack_public_path__ + "img/violet_125.916420c6.png";